module.exports = __webpack_public_path__ + "img/increase-motivation.56af6bcb.svg";